// extracted by mini-css-extract-plugin
export default {"container":"BgOrangeBlur_container__JkszQ"};